import {DevConfig} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

export function createDevConfigs(useNewBrandDesign?: boolean) {
  return useNewBrandDesign ? devConfigV26 : devConfig;
}

export const devConfig: DevConfig = {
  modelCombinedDropdowns: true,
  tireCombinedDropdowns: true,
  usePreHeatedData: false,
  showEditPriceButton: true,
};

export const devConfigV26: DevConfig = {
  ...devConfig,
  colors: {
    temperatureSliderColours: {
      '-20': '#4C0789',
      '-10': '#3064D0',
      '0': '#D5AE00',
      '10': '#FFD100',
      '20': '#E4002C',
    },
  },
};
